var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtRetirementSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.84 1.741H1.65l-.21 1.712A1.745 1.745 0 0 1 0 1.741C0 .78.785 0 1.754 0h.29a1.77 1.77 0 0 1 .903.25h.002c.462.279.786.76.84 1.32.005.054.009.11.009.165v.006c0 .081-.008.161-.019.24a1.703 1.703 0 0 1-.289.743l-.053.071c-.013.017-.026.037-.04.054-.12.145-.266.27-.428.37a1.747 1.747 0 0 1-.926.264h-.29c-.044 0-.086-.004-.128-.007l.213-1.735h.003z",
    id: "wrt5n922ba"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.25 9.625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 29.313,
    cy: 49.192,
    rx: 29.313,
    ry: 1.558
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5B045",
    d: "m10.167 31.3-9.398-.69L16.136 3.799zM43.61 10.68l3.545-8.667-31.02 1.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5B045",
    d: "m16.136 3.798 17.42 15.547-11.11 6.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E7DD",
    d: "M16.136 3.798 43.61 10.68l-10.054 8.665zM16.136 3.798 10.166 31.3l12.28-5.106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.801.065a.435.435 0 0 1 .597.139L44.86 48.908h-1.02L13.66.658a.429.429 0 0 1 .14-.593z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.478 13.938c-9.232 5.69-16.75 11.84-20.881 16.733l-.828-.06 3.405-4.423 10.81-12.509 10.583-6.523 16.086-4.073 5.502-1.07-.312.762c-6.249 1.507-15.134 5.47-24.365 11.161v.002z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m.77 30.61 3.404-4.422 11.962-22.39zM47.155 2.013l-5.5 1.07-25.52.715zM16.136 3.798l9.43 3.358-10.58 6.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m16.136 3.798 25.518-.715-16.087 4.073zM16.136 3.798 4.174 26.188 14.985 13.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.753 26.663)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M5.682 20.095 7.949 6.759l.88.147L6.56 20.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m8.39 8.663-.58-.408.284-1.61.324.053.284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m1.723 20.732 31.054-10.538.521 1.513L2.244 22.245z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 3.479,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m18.893 16.594-1.578-1.154 1.854-.63 1.578 1.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 1.388.955.101l28.52 20.853-.954 1.288z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.283,
    cy: 21.063,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.841,
    cy: 21.063,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M6.24 20.095 8.505 6.759l.88.147-2.267 13.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M8.948 8.663h-.58l.284-2.018.325.053.283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#522D0E",
    d: "m2.802 22.245 31.054-10.54-.52-1.512L2.28 20.731l-.035 1.514z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 4.037,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M19.45 16.594h-.557l-1.02-1.154 1.854-.63 1.578 1.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m.557 1.39 28.521 20.855.954-1.288-7.428-5.433h-.557l.25-.224L1.512.102H.955z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "M5.682 20.095 7.949 6.759l.88.147L6.56 20.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m8.39 8.663-.58-.408.284-1.61.324.053.284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#784114",
    d: "m1.723 20.732 31.054-10.538.521 1.513L2.244 22.245z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 3.479,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#733F14",
    d: "m18.893 16.594-1.578-1.154 1.854-.63 1.578 1.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#824716",
    d: "M0 1.388.955.101l28.52 20.853-.954 1.288z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.283,
    cy: 21.063,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M33.336 10.193h-.558l.52 1.513h.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M30.032 20.957h-.557l-.954 1.288h.557z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5E3411"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.434 11.26c0 .383.314.694.7.694.387 0 .7-.311.7-.695a.697.697 0 0 0-.7-.695c-.386 0-.7.312-.7.695zM.811 1.522c0 .384.314.695.7.695.387 0 .7-.311.7-.695a.697.697 0 0 0-.7-.695c-.386 0-.7.312-.7.695z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M40.929 37.229h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.089 37.229h2.159v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M45.248 37.229h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M47.408 37.229h2.159v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M49.567 37.229h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.187 37.923c0 .383.314.694.7.694.387 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.753 44.42c2.79 0 5.705-.855 8.575-2.536 2.966-1.738 4.816-3.708 4.892-3.79h-2.16a60.898 60.898 0 0 1-4.319 3.04c-2.589 1.647-5.482 3.4-9.919 2.329-6.663-1.609-14.213-15.285-14.289-15.423h-2.16c2.426 5.099 7.355 14.246 16.302 16.02 1.01.2 2.03.362 3.075.362l.003-.001z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M51.727 37.229h2.159v1.388h-2.16zM21.104 27.492h2.159v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M18.944 27.492h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.785 27.492h2.159v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M14.625 27.492h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12.466 27.492h2.159v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B7690",
    d: "M10.306 27.492h2.16v1.388h-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.564 28.186c0 .383.314.694.7.694.387 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.404 28.186c0 .383.314.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695zM51.027 37.923c0 .383.314.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.592 44.42c2.791 0 5.706-.855 8.576-2.536 2.966-1.738 4.815-3.708 4.892-3.79h-2.159c-.018.02-1.386 1.293-3.768 2.876-2.555 1.698-6.034 3.562-10.47 2.491C29 41.853 21.45 28.177 21.374 28.04h-2.159c.313.573 7.626 14.194 14.554 15.868 1.002.242 3.777.514 4.822.514h.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.245 28.186c0 .383.314.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695zM48.868 37.923c0 .383.314.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.386 0-.7.31-.7.695z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.433 44.42c2.791 0 5.706-.855 8.576-2.536 2.966-1.738 4.815-3.708 4.892-3.79h-2.16c-.019.02-1.255 1.35-4.147 3.04-2.65 1.549-5.654 3.4-10.09 2.329-6.663-1.609-14.213-15.285-14.289-15.423h-2.16c.248.915 7.458 14.238 14.387 15.912 1.002.242 3.945.471 4.99.471l.001-.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.085 28.186c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695zM46.708 37.923c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.273 44.42c2.79 0 5.705-.855 8.575-2.536 2.967-1.738 4.816-3.708 4.893-3.79h-2.159c-.019.02-1.061 1.093-3.954 2.784-2.65 1.55-5.847 3.654-10.283 2.583-6.663-1.608-14.213-15.284-14.289-15.422h-2.159c.314.573 7.401 14.107 14.33 15.78 1.002.242 4.002.603 5.047.603v-.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.926 28.186c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695zM44.549 37.923c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.114 44.42c2.791 0 5.705-.855 8.575-2.536 2.967-1.738 4.816-3.708 4.893-3.79h-2.16c-.019.02-1.478 1.339-4.37 3.03-2.65 1.55-5.432 3.408-9.868 2.337-6.663-1.608-14.214-15.284-14.29-15.422h-2.16c.314.573 7.435 14.364 14.364 16.036 1.002.242 3.968.346 5.014.346h.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.766 28.186c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695zM42.389 37.923c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.954 44.42c2.79 0 5.705-.855 8.575-2.536 2.967-1.738 4.816-3.708 4.893-3.79h-2.16c-.018.02-1.464 1.36-3.861 2.897-2.583 1.655-5.94 3.543-10.376 2.47-6.663-1.608-14.214-15.284-14.29-15.422h-2.158c.313.573 7.303 14.025 14.23 15.698 1.003.242 4.102.684 5.146.684h.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.795 44.42c2.79 0 5.705-.855 8.575-2.536 2.967-1.738 4.816-3.708 4.893-3.79l-.455-.417c-.018.02-1.875 1.996-4.767 3.686-2.65 1.55-6.738 3.17-11.174 2.1-6.663-1.609-14.213-15.285-14.289-15.423l-.544.294c.314.573 7.758 14.054 14.687 15.726 1.002.242 2.03.362 3.075.362v-.001z",
    fill: "#DB1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.963 28.282c0 .237-.045.459-.12.641H10.66v-.885h13.287c.01.077.016.158.016.242v.002z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.404 43.88c1.631-.266 4.552-1.588 4.552-1.588l.036-.151.214.14a27.465 27.465 0 0 0 2.196-1.291 32.308 32.308 0 0 0 3.528-2.6v-.467h13.657a.697.697 0 0 1-.7.694h-.193a24.553 24.553 0 0 1-4.365 3.267c-2.87 1.68-5.785 2.537-8.575 2.537-.34 0-.679-.019-1.016-.05-.383.032-.764.05-1.144.05-.26 0-.627-.018-1.046-.046-.373.03-.744.046-1.113.046-.265 0-.653-.015-1.1-.041-.356.027-.709.04-1.06.04-.24 0-.585-.02-.985-.051a13.98 13.98 0 0 1-1.174.052c-.308 0-.78-.01-1.322-.029-.28.017-.56.029-.839.029-.598 0-1.866-.146-3.03-.314.832-.005 2.353-.043 3.48-.226h-.001z",
    fill: "#000",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.886 38.808H40.929v-.885h13.657c0 .489-.314.885-.7.885z",
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.795 44.42c2.79 0 5.705-.855 8.575-2.536 2.967-1.738 4.816-3.708 4.893-3.79l-.455-.417c-.018.02-1.875 1.996-4.767 3.686-2.65 1.55-6.738 3.17-11.174 2.1-6.663-1.609-14.213-15.285-14.289-15.423l-.544.294c.314.573 7.758 14.054 14.687 15.726 1.002.242 2.03.362 3.075.362v-.001z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.607 28.186c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695zM40.23 37.923c0 .383.313.694.7.694.386 0 .7-.31.7-.694a.697.697 0 0 0-.7-.695c-.387 0-.7.31-.7.695z",
    fill: "#D61A1A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.24 26.663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.99 11.26c0 .383.314.695.7.695.387 0 .7-.312.7-.695a.697.697 0 0 0-.7-.695c-.386 0-.7.311-.7.695zM1.368 1.523c0 .383.313.695.7.695.386 0 .7-.312.7-.695a.697.697 0 0 0-.7-.695c-.387 0-.7.311-.7.695z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B1B",
    d: "M1.24 1.097h1v1h-1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M5.681 20.095 7.948 6.759l.88.147L6.56 20.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m8.39 8.664-.581-.408.284-1.61.324.053.284.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m1.722 20.732 31.054-10.538.52 1.513L2.242 22.245z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 3.478,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m18.892 16.594-1.578-1.153 1.854-.63 1.578 1.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 1.388.955.101l28.52 20.853-.954 1.288z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.282,
    cy: 21.063,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.84,
    cy: 21.063,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M6.238 20.095 8.506 6.76l.879.147-2.267 13.337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#542E0F",
    d: "M8.947 8.664h-.58l.284-2.018.325.053.283.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m2.8 22.245 31.055-10.539-.52-1.512L2.279 20.73l-.037 1.514z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 4.036,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#703E13",
    d: "M19.45 16.594h-.558l-1.02-1.153 1.854-.63 1.578 1.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "m.556 1.39 28.521 20.855.954-1.287-7.428-5.433h-.557l.25-.224L1.51.102H.954z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M5.681 20.095 7.948 6.759l.88.147L6.56 20.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#613511",
    d: "m8.39 8.664-.581-.408.284-1.61.324.053.284.199z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "m1.722 20.732 31.054-10.538.52 1.513L2.242 22.245z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 3.478,
    cy: 20.971,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "m18.892 16.594-1.578-1.153 1.854-.63 1.578 1.155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4D18",
    d: "M0 1.388.955.101l28.52 20.853-.954 1.288z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5E3411",
    cx: 28.282,
    cy: 21.063,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9C561B",
    d: "M33.335 10.194h-.558l.52 1.512h.558z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A4315",
    d: "M30.031 20.958h-.557l-.954 1.287h.557z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.145 42.44 4.168-5.534 1.183.878-4.169 5.534z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.052 37.475.534-.709 1.183.878-.535.71z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.943 42.118a.44.44 0 0 0 .09.62.448.448 0 0 0 .625-.09.44.44 0 0 0-.09-.62.446.446 0 0 0-.623.09h-.002z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m11.845 42.44 4.168-5.534 1.183.878-4.168 5.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m15.752 37.476.534-.709 1.182.878-.534.709zM12.642 42.118a.44.44 0 0 0 .09.62.448.448 0 0 0 .625-.09.44.44 0 0 0-.09-.62.45.45 0 0 0-.626.09h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M7.96 48.928h9.86l.776-6.067H7.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M14.063 42.861h2.345v1.516h-2.345zM9.374 42.861h2.345v1.516H9.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M18.261 45.894h-.681v-1.516h.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A66B29",
    d: "M7.023 41.84H18.76v1.021H7.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332318",
    d: "M7.185 41.678h11.41v1H7.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD934E",
    d: "M7.023 41.222H18.76v1H7.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "M8.201 44.377h2.345v1.516H8.201zM12.89 44.377h2.345v1.516H12.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8631F",
    d: "M14.063 45.894h2.345v1.516h-2.345zM9.374 45.894h2.345v1.516H9.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A35714",
    d: "m18.472 47.411-.399 1.517h-.493V47.41zM8.201 47.411h2.345v1.516H8.201zM12.89 47.411h2.345v1.516H12.89z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#AD6F2B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.408 44.378V42.86h2.188l-.194 1.517zM7.379 44.378l-.194-1.517h2.189v1.517zM11.718 42.861h2.345v1.516h-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.235 44.377h2.345v1.516h-2.345zM7.379 44.378h.891v1.516h-.68zM10.545 44.377h2.345v1.516h-2.345zM18.015 47.411h-1.607v-1.517h1.8zM7.573 45.894h1.801v1.517H7.767zM11.718 45.894h2.345v1.516h-2.345zM15.235 47.411h2.345v1.516h-2.345zM8.66 47.411v1.517h-.495l-.398-1.517zM10.545 47.411h2.345v1.516h-2.345z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M18.541 43.291H13.37l-.342.456-.612-.456H7.24l-.055-.43h11.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.1,
    d: "M16.34 38.917h-1.843l.691-.917h1.843z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M4.132 48.928h9.86l.775-6.067H3.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M12.58 44.378V42.86h2.187l-.193 1.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M10.235 42.861h2.345v1.516h-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "m3.55 44.378-.193-1.517h2.188v1.517zM7.89 42.861h2.345v1.516H7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M5.546 42.861H7.89v1.516H5.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M14.432 45.894h-.68v-1.516h.891z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M3.193 41.84H14.93v1.021H3.193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#453021",
    d: "M3.357 41.678h11.41v1H3.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1A356",
    d: "M3.193 41.222H14.93v1H3.193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M11.406 44.377h2.345v1.516h-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M4.372 44.377h2.345v1.516H4.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M3.55 44.378h.892v1.516H3.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M9.062 44.377h2.345v1.516H9.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M6.717 44.377h2.345v1.516H6.717zM14.186 47.411H12.58v-1.517h1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M10.235 45.894h2.345v1.516h-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M3.744 45.894h1.801v1.517H3.94zM7.89 45.894h2.345v1.516H7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B86C22",
    d: "M5.545 45.894H7.89v1.516H5.545z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "m14.643 47.411-.399 1.517h-.493V47.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M11.406 47.411h2.345v1.516h-2.345z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M4.372 47.411h2.345v1.516H4.372z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M4.83 47.411v1.517h-.494L3.94 47.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B15F15",
    d: "M9.062 47.411h2.345v1.516H9.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M9.374 41.222h1.844l-1.235 1.64H8.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE7A2F",
    d: "M6.717 47.411h2.345v1.516H6.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    opacity: 0.3,
    d: "M14.713 43.291H9.54l-.342.456-.612-.456H3.411l-.054-.43h11.41z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#A16F31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.016 42.439 4.169-5.534 1.182.878-4.168 5.534z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.923 37.48.534-.71 1.182.878-.534.709z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.814 42.118a.44.44 0 0 0 .09.62.448.448 0 0 0 .624-.09.44.44 0 0 0-.09-.62.448.448 0 0 0-.624.09z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m7.716 42.437 4.168-5.534 1.183.878-4.169 5.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4883C",
    d: "m11.623 37.475.534-.709 1.183.878-.534.709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.514 42.118a.44.44 0 0 0 .09.62.448.448 0 0 0 .624-.09.44.44 0 0 0-.09-.62.448.448 0 0 0-.624.09z",
    fill: "#BE7A2F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M17.166 38.667h-4.43l.332-.886h4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D19040",
    d: "M16.314 36.903h-4.43l1.184.886h4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16F31",
    d: "M13.038 38.219h-.301L8.9 43.315h.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.325 39.71h2.353c.505 0 .917.408.917.91 0 .06-.05.11-.11.11h-.063v-.02a.11.11 0 0 1-.047-.09.696.696 0 0 0-.697-.693h-2.353a.11.11 0 0 1-.11-.11c0-.06.05-.109.11-.109v.001z",
    fill: "#7A8FA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.071 40.603h.159c0-.39.201-.709.45-.709.25 0 .451.318.451.71h.159c0-.489-.274-.886-.61-.886-.335 0-.609.397-.609.885zM16.266 39.71h2.352c.505 0 .918.408.918.91a.11.11 0 0 1-.22 0 .696.696 0 0 0-.698-.692h-2.352a.11.11 0 0 1-.11-.11c0-.06.05-.109.11-.109z",
    fill: "#A3BFD6"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0E0E1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.955 40.005c0 .672.566 1.217 1.265 1.217s1.265-.545 1.265-1.217c0-.673-.566-.789-1.265-.789s-1.265.115-1.265.789zM11.879 40.005c0 .672.566 1.217 1.264 1.217.699 0 1.265-.545 1.265-1.217 0-.673-.566-.789-1.265-.789-.698 0-1.264.115-1.264.789z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#191A2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.849 40.005c0 .672.566 1.217 1.265 1.217.698 0 1.264-.545 1.264-1.217 0-.673-.566-.789-1.264-.789-.699 0-1.265.115-1.265.789zM11.772 40.005c0 .672.566 1.217 1.265 1.217.698 0 1.264-.545 1.264-1.217 0-.673-.566-.789-1.264-.789-.699 0-1.265.115-1.265.789z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.27 40.494c-.195.43-.64.73-1.158.73-.613 0-1.124-.421-1.24-.98.874.038 1.686.126 2.398.25zM13.828 40.22c.153 0 .302.001.452.005-.107.568-.623.998-1.243.998-.62 0-1.085-.388-1.225-.915.633-.056 1.31-.088 2.016-.088z",
    fill: "#0E0E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.799 39.29.31.428c.075.102.06.25-.03.332a.197.197 0 0 1-.3-.034l-.579-.798c.22.004.425.023.6.073h-.001z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.055 39.47.922 1.131a.21.21 0 0 1-.164.343.214.214 0 0 1-.165-.077l-.793-.973a.637.637 0 0 1 .2-.424z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.846 39.615a.293.293 0 0 1 .41.043l.873 1.07c-.117.155-.274.28-.452.367l-.874-1.072a.288.288 0 0 1 .043-.407v-.001z",
    fill: "#7A90A1",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.037 39.218c.188 0 .366.009.526.037l.354.474c.075.1.06.243-.03.323a.2.2 0 0 1-.299-.035l-.598-.798h.046v-.001z",
    fill: "#46565C",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.772 40.005c0-.198.05-.348.136-.46l.879 1.077a.21.21 0 0 1-.165.343.212.212 0 0 1-.165-.079l-.684-.838v-.045.002z",
    fill: "#617280",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.656 39.637a.293.293 0 0 1 .41.043l.92 1.129a1.262 1.262 0 0 1-.482.328l-.89-1.092a.288.288 0 0 1 .042-.407v-.001z",
    fill: "#7A90A1",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.65 33.648)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C86BD",
    fillRule: "nonzero",
    d: "M1.213 7.09h2.451v1H1.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5597D4",
    fillRule: "nonzero",
    d: "M1.213 7.09h2.452l.525-4.277H.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "M3.999 2.813 3.496 6.9H1.38L.88 2.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7092B3",
    fillRule: "nonzero",
    d: "M3.999 2.813 3.496 6.9H1.38L.88 2.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7A016",
    fillRule: "nonzero",
    d: "m3.917 3.474-.42 3.427H1.38L.96 3.474z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79216",
    fillRule: "nonzero",
    d: "M2.757 3.474h1.16l-.42 3.427h-.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E37F05",
    fillRule: "nonzero",
    d: "M3.506 3.474h.632l-.56 3.427h-.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    d: "M1.364 3.474h.892v3.427H1.7zM3.181 4.27a.46.46 0 1 0 .919 0 .46.46 0 0 0-.919 0zm.082.081a.46.46 0 1 1 .92.002.46.46 0 0 1-.92-.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.238 4.887a.46.46 0 1 0 .918 0 .46.46 0 0 0-.918 0zm.081.081a.46.46 0 1 1 .92.002.46.46 0 0 1-.92-.002z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.624 6.39a.46.46 0 1 0 .919 0 .46.46 0 0 0-.919 0zm.082.082a.46.46 0 1 1 .92.002.46.46 0 0 1-.92-.002zM1.19 4.112a.445.445 0 0 0 .893 0 .445.445 0 0 0-.892 0zm.115.113a.446.446 0 0 1 .892 0 .446.446 0 0 1-.892 0z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.853 5.61a.445.445 0 0 0 .892 0 .445.445 0 0 0-.892 0zm.114.113a.446.446 0 0 1 .892 0 .446.446 0 0 1-.892 0z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 4.783c0 .212.17.38.384.38a.38.38 0 0 0 .383-.38.385.385 0 0 0-.383-.38.385.385 0 0 0-.384.38z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.046 4.006c0 .246.2.442.45.442a.443.443 0 1 0 0-.885.447.447 0 0 0-.45.443zM3.433 6.34a.446.446 0 0 0 .892 0 .446.446 0 0 0-.892 0z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFAF36",
    fillRule: "nonzero",
    cx: 2.882,
    cy: 6.463,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.002 7.09c0 .242.202.443.446.443s.446-.2.446-.443a.447.447 0 0 0-.446-.443c-.244 0-.446.2-.446.443zM1.25 4.039c0 .177.143.328.33.328.187 0 .33-.151.33-.328a.334.334 0 0 0-.33-.328.328.328 0 0 0-.33.328zM2.137 4.204a.445.445 0 0 0 .892 0 .445.445 0 0 0-.892 0z",
    fill: "#FFAF36",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.735 5.158c0 .241.197.443.446.443a.44.44 0 0 0 .446-.443.444.444 0 0 0-.446-.443.44.44 0 0 0-.446.443z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.278 5.83c0 .22.179.398.402.398a.398.398 0 1 0 0-.797.398.398 0 0 0-.402.398z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76 4.753a1.797 1.797 0 0 1-1.448-1.94h1.687l-.24 1.94z",
    fill: "#A15A0E",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.428 5.98c0 .246.199.443.445.443a.444.444 0 1 0 0-.885.444.444 0 0 0-.445.443z",
    fill: "#E37F05",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.519 5.913h.54c.12 0 .218.097.218.217v.536c0 .119-.098.216-.218.216h-.54a.218.218 0 0 1-.218-.216V6.13c0-.12.098-.217.218-.217z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.594 6.369v.43l-.892-.58.089-.306h.098l.703.456h.002z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "m3.53 7.004-.892-.496.133-.39.758.421z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.219 5.913h.54c.12 0 .218.097.218.217v.536c0 .119-.098.216-.218.216h-.54a.218.218 0 0 1-.218-.216V6.13c0-.12.098-.217.218-.217z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.819 6.897h.258c.125 0 .225-.061.225-.134v-.616c0-.075-.102-.134-.225-.134h-.511c-.088 0-.156.04-.156.093 0 .052.068.093.156.093h.426v.513h-.17c-.086 0-.157.04-.157.093 0 .052.071.093.156.093l-.002-.001z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.356 6.897c.144 0 .257-.1.257-.23V6.47h.124c.144 0 .257-.1.257-.23 0-.128-.113-.229-.257-.229h-.264c-.207 0-.37.15-.37.33v.327c0 .125.116.229.257.229h-.004z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#779CBF",
    fillRule: "nonzero",
    d: "M1.358 3.698h.808v-.885h-.892z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.523 5.42.199-.499a.219.219 0 0 1 .282-.122l.503.197c.112.044.167.17.123.281l-.199.499a.219.219 0 0 1-.283.122L2.646 5.7a.216.216 0 0 1-.123-.281z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.019 5.495a.187.187 0 0 1-.011.032l-.106.25-.775-.72.178-.166.102.038.61.568.002-.002z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "M3.704 5.957 2.959 5.3l.257-.227.634.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.244 5.318.198-.499a.219.219 0 0 1 .283-.122l.502.197c.112.044.167.17.123.281l-.198.499a.219.219 0 0 1-.283.122l-.503-.198a.216.216 0 0 1-.122-.28z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.816 5.703.208.052c.101.025.215-.006.254-.07l.33-.534c.038-.065-.011-.137-.112-.163l-.414-.104c-.07-.017-.148.004-.175.049-.027.044.006.094.076.113l.344.086-.274.444-.138-.035c-.07-.017-.148.004-.177.049-.027.044.006.094.076.113h.002z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.627 5.647c.114.049.24-.011.283-.138l.07-.198.097.045c.113.048.24-.011.286-.138.043-.127-.01-.27-.123-.322l-.213-.093c-.163-.071-.346.019-.41.202l-.116.325c-.043.127.01.269.123.32l.003-.003z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF6",
    d: "M0 .34.84.044l2.374 6.635-.84.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFD7DE",
    d: "m.007.38.84-.297 2.374 6.635-.84.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C93E47",
    d: "m.277.304.84-.297 2.378 6.634-.84.297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AB2E36",
    d: "m.074.377.84-.296 2.371 6.636-.84.296z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.646 5.357.456-.287a.22.22 0 0 1 .301.066l.29.453c.064.1.034.235-.067.299l-.456.287a.22.22 0 0 1-.301-.066l-.29-.453a.216.216 0 0 1 .067-.299z",
    fill: "#74ACC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.606 5.116.017.061.122.486-.86.339-.031-.5.074-.117.68-.269h-.002z",
    fill: "#8ACEEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B9FB5",
    d: "m2.835 5.914-.846.293-.046-.64.72-.245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.396 5.515.455-.288a.22.22 0 0 1 .301.066l.29.453c.065.1.035.235-.067.299l-.455.287a.22.22 0 0 1-.301-.066l-.29-.453a.216.216 0 0 1 .067-.298z",
    fill: "#86C7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.33 6.162.138-.084a.136.136 0 0 0 .044-.19l-.352-.532a.146.146 0 0 0-.197-.042l-.275.167a.092.092 0 0 0-.03.132.1.1 0 0 0 .137.029l.228-.139.294.442-.092.057a.092.092 0 0 0-.03.131.1.1 0 0 0 .137.03H2.33z",
    fill: "#97E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.082 6.394c.137-.061.176-.184.088-.28l-.136-.15.119-.052c.136-.061.176-.184.092-.28-.088-.095-.264-.122-.4-.06l-.256.113c-.193.086-.25.267-.127.402l.22.243c.088.095.264.123.4.061v.003z",
    fill: "#97E0FF"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6583A1",
    fillRule: "nonzero",
    d: "M4.2 3.698h-.76l.058-.885h.833z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.35 1.072)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "go6ffqesmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wrt5n922ba"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#go6ffqesmb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.453 -.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.778 2.211c0-.846.62-1.546 1.434-1.68V.506h.284c.949 0 1.718.763 1.718 1.705 0 .942-.77 1.706-1.718 1.706h-.284V3.89a1.708 1.708 0 0 1-1.434-1.68z",
    fill: "#FF9500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.349 2.483c0-.196.151-.358.374-.439.036.29.054.588.063.885-.25-.067-.428-.236-.428-.452l-.01.006z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.04 2.301c0-.168.143-.31.312-.31.17 0 .313.142.313.31s-.143.31-.313.31a.315.315 0 0 1-.312-.31z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.064 2.049c0 .168.143.31.312.31.17 0 .312-.142.312-.31a.31.31 0 0 0-.312-.31.315.315 0 0 0-.312.31z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.828 1.707c0 .204.17.372.366.372a.381.381 0 0 0 .374-.372.375.375 0 0 0-.374-.372.368.368 0 0 0-.366.372z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.759 1.403c0 .107.089.195.196.195a.197.197 0 0 0 .196-.195.197.197 0 0 0-.196-.194.197.197 0 0 0-.196.194z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.725 1.453a.398.398 0 0 1-.401-.398c0-.098.035-.186.098-.257.232.115.454.248.677.38a.397.397 0 0 1-.374.266v.009z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.979 1.079c0 .239.196.442.446.442a.44.44 0 0 0 .446-.442.44.44 0 0 0-.446-.443.44.44 0 0 0-.446.443z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.505.865a.277.277 0 0 1-.552 0c0-.044.008-.08.026-.115.179.035.348.07.526.115z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.313 1.371c0 .245.2.443.446.443a.445.445 0 0 0 .446-.443c0-.244-.2-.442-.446-.442a.445.445 0 0 0-.446.442zM3.8 2.738c0 .247.202.442.446.442s.446-.2.446-.442a.447.447 0 0 0-.446-.443c-.244 0-.446.2-.446.443z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.919 3.084c0 .241.196.443.446.443a.44.44 0 0 0 .446-.443.44.44 0 0 0-.446-.442.44.44 0 0 0-.446.442z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.916 3.338c0 .221.179.398.402.398a.398.398 0 1 0 0-.797.398.398 0 0 0-.402.399z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.391 3.164c.098 0 .179.025.259.066-.205.282-.428.555-.66.82a.501.501 0 0 1-.16-.364c0-.29.25-.522.561-.522z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FA8C16",
    fillRule: "nonzero",
    cx: 4.106,
    cy: 3.621,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.692 3.787c0 .159.133.292.294.292.16 0 .294-.133.294-.292a.296.296 0 0 0-.294-.293.296.296 0 0 0-.294.293z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.285 3.807a.445.445 0 0 0 .892 0 .445.445 0 0 0-.892 0z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.736 3.649c.212 0 .389.15.433.354-.238.15-.477.301-.733.434a.438.438 0 0 1-.159-.337c0-.247.203-.451.45-.451h.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.199 4.11c0 .16.133.292.294.292.16 0 .294-.133.294-.292a.296.296 0 0 0-.294-.292.296.296 0 0 0-.294.292z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.845 4.171c0 .23.187.408.41.408.223 0 .41-.186.41-.408a.408.408 0 0 0-.41-.407.413.413 0 0 0-.41.407zM4.775 2.446a7.185 7.185 0 0 1-.187.886c-.16-.091-.268-.235-.268-.41 0-.234.196-.423.455-.476z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.241 2.64c0 .14.116.256.259.256a.258.258 0 0 0 .258-.257.258.258 0 0 0-.258-.257.258.258 0 0 0-.259.257zM4.139 1.64c0-.09.027-.169.062-.24.152.248.286.496.42.753a.521.521 0 0 1-.482-.514z",
    fill: "#FA8C16",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E07E14",
    cx: 2.212,
    cy: 2.211,
    rx: 1.718,
    ry: 1.706
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF9E16",
    transform: "rotate(-45 2.211 2.211)",
    cx: 2.211,
    cy: 2.211,
    r: 1.564
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.698 2.211c0 .83.678 1.503 1.514 1.503s1.514-.673 1.514-1.503c0-.83-.678-1.502-1.514-1.502S.698 1.38.698 2.21z",
    fill: "#F7E6B4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.277 2.035a.1.1 0 0 0 .092-.056L2.771.957c.018-.044-.01-.092-.06-.107a1.531 1.531 0 0 0-.868 0c-.051.015-.078.063-.061.107l.402 1.022c.013.034.051.056.093.056zM2.277 3.635c.146 0 .292-.02.433-.062.051-.015.079-.063.061-.107L2.37 2.444a.098.098 0 0 0-.092-.057.1.1 0 0 0-.093.057l-.402 1.022c-.017.044.01.09.06.107.14.041.288.062.433.062h.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.337 2.087a.085.085 0 0 0 .098.016l.975-.477a.083.083 0 0 0 .038-.112 1.164 1.164 0 0 0-.533-.529.083.083 0 0 0-.112.038l-.48.968a.084.084 0 0 0 .015.097v-.001zM1.198 3.218c.089.09.194.164.31.22.043.021.093.004.115-.038l.48-.967a.085.085 0 0 0-.114-.113l-.975.477a.083.083 0 0 0-.038.112c.057.115.131.22.222.308v.001z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.388 2.28a.1.1 0 0 0 .057.093l1.03.402c.044.017.092-.01.107-.061a1.52 1.52 0 0 0 0-.867c-.015-.052-.063-.079-.108-.062l-1.03.402c-.034.013-.056.052-.056.093zM.778 2.28c0 .147.02.292.063.434.015.051.063.078.108.061l1.029-.402c.035-.013.057-.052.057-.093a.098.098 0 0 0-.057-.093l-1.03-.402c-.044-.017-.091.01-.107.06a1.52 1.52 0 0 0-.063.434v.001z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F7A016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.337 2.335a.084.084 0 0 0-.016.098l.48.967a.084.084 0 0 0 .113.039 1.137 1.137 0 0 0 .533-.53.084.084 0 0 0-.038-.111l-.975-.477a.085.085 0 0 0-.098.016l.001-.002zM1.198 1.204c-.09.089-.165.193-.222.309a.082.082 0 0 0 .038.112l.975.477c.032.016.072.01.098-.016a.082.082 0 0 0 .016-.096l-.48-.968A.084.084 0 0 0 1.51.984a1.164 1.164 0 0 0-.311.22h-.001z"
  })))))), /*#__PURE__*/React.createElement("path", {
    fill: "#4578AB",
    fillRule: "nonzero",
    d: "M2.27 7.09h1.312v1H2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4171A1",
    fillRule: "nonzero",
    d: "M2.989 7.09h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518FC9",
    fillRule: "nonzero",
    d: "M1.399 7.09h1v1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M3.496 6.9H1.38L.88 2.814h3.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.966 4.528c.01-.13.172-.228.362-.221.187.009.33.12.318.25l-.209 2.345h-.682l.213-2.374h-.002zM1.954 2.813l.137 1.39c.013.131-.145.243-.352.252-.21.008-.385-.091-.399-.222l-.14-1.42h.754z",
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M2.238 2.813h1.761L3.496 6.9H2.238z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtRetirementSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-retirement-small.4eec729d70df53fea226e0438f150a0a.svg";